import { faLocationArrow, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import React from "react";
// import { faShareAlt } from "@fortawesome/free-solid-svg-icons";
import ReactHtmlParser, { convertNodeToElement } from "react-html-parser";
import styled from "styled-components";
import { getIconUrl } from "../../plugins/unt/assets/iconUrls";
import PluginCloseButton from "./PluginCloseButton";
import PluginHeader from "./PluginHeader";
import PluginSection from "./PluginSection";
import PluginText from "./PluginText";
import PluginWrapper from "./PluginWrapper";

const Action = styled.button.attrs({
  className: "pv3-ns ph4-ns pa1 mh2 ttu bg-white",
})`
  color: #81334e;
  border: 3px solid rgba(129, 51, 78, 0.3);
  svg {
    margin-right: 1rem;
  }
  a {
    color: #81334e;
  }
`;

const SpotIcon = styled.div.attrs(() => ({
  className: "mr2 dib",
}))`
  background-image: url(${(props) => getIconUrl(props.icon)});
  background-size: contain;
  background-repeat: no-repeat;
  height: 18px;
  width: 18px;
`;

class SpotPopup extends React.Component {
  state = {
    contentSections: {},
    poiData: null,
  };

  componentDidMount() {
    if (this.props.locationPathname !== "/dein-ulm") {
      fetch(
        `https://tourismus.ulm.de/api/poi/${this.props.selectedFeature.properties.id}`,
        { headers: { "accept-language": "de" } }
      )
        .then((res) => res.json())
        .then((poiData) => this.setState({ poiData }));
    } else {
      // this.setState({ poiData: this.props.selectedFeature })
    }
  }

  transformATagToOpenLinkInNewWindow(node, index) {
    if (node.type === "tag" && node.name === "a") {
      return (
        <a
          href={node.attribs.href}
          key={index}
          target="_blank"
          rel="noopener noreferrer"
        >
          {node.children[0].data}
        </a>
      );
    }
    return convertNodeToElement(node, index);
  }

  toggleVisibilityOfContentSection = (contentSectionName) => {
    const contentSectionNameValue = this.state.contentSections[
      contentSectionName
    ];

    const contentSectionVisibility =
      !contentSectionNameValue || contentSectionNameValue === ""
        ? "isVisible"
        : "";
    this.setState({
      contentSections: {
        ...this.state.contentSections,
        [contentSectionName]: contentSectionVisibility,
      },
    });
  };

  navigateToSpotLocation = (
    latitude = this.state.latitude,
    longitude = this.state.longitude,
    openInNewWindow = true
  ) => {
    window.open(
      `http://maps.apple.com/maps?q=${latitude},${longitude}`,
      openInNewWindow ? "_blank" : "_top"
    );
  };

  parsePoiData = (poiData, language = "de") => {
    let poiDataParsed = null;
    if (!!poiData) {
      poiDataParsed = {
        text: poiData[`text_Text_${language}`],
        street: poiData.input_Str,
        city: poiData.input_Ort,
        postcode: poiData.int_PLZ,
        lat: poiData.float_Lat,
        lng: poiData.float_Lng,
      };
    }

    return poiDataParsed;
  };

  render() {
    const { selectedFeature, onSpotPopupClose, geolocatePosition } = this.props;
    const { poiData } = this.state;
    const isDeinUlm = selectedFeature.properties.isDeinUlm;
    console.log("poiData: ", poiData);

    let icon = isDeinUlm ? "" : selectedFeature.properties.icon_url;
    let name = isDeinUlm
      ? selectedFeature.properties.title
      : selectedFeature.properties.name;

    // let distanceToGeolocateInfo = null;
    // if (!!geolocatePosition) {
    //   const { latitude, longitude } = geolocatePosition.coords;
    //   var from = point([longitude, latitude]);
    //   var to = point([poiData.lng, poiData.lat]);
    //   var options = { units: "kilometres" };

    //   var distanceInfo = distance(from, to, options);
    //   console.log("distanceInfo", distanceInfo);

    //   // console.log("feature coordinates", selectedFeature.geometry.coordinates);

    //   distanceToGeolocateInfo = (
    //     <time className="f6 ttu tracked gray">
    //       Entfernung: {parseInt(distanceInfo * 1000, 10)} m
    //     </time>
    //   );
    // }

    if (!isDeinUlm && !poiData) {
      return (
        <PluginWrapper>
          <div className="flex items-center justify-center h-100">
            <FontAwesomeIcon
              className="f1"
              style={{ color: "rgba(129,51,78, 1)" }}
              icon={faSpinner}
              spin
            />
          </div>
        </PluginWrapper>
      );
    }

    // let socialLinks = [];
    // if (!isDeinUlm) {
    //   if (poiData.facebook) {
    //     socialLinks.push(
    //       <a key="facebook" href={poiData.facebook}>
    //         facebook
    //       </a>
    //     );
    //   }
    //   if (poiData.twitter) {
    //     socialLinks.push(
    //       <a key="twitter" href={poiData.twitter}>
    //         twitter
    //       </a>
    //     );
    //   }
    //   if (poiData.instagram) {
    //     socialLinks.push(
    //       <a key="instragram" href={poiData.instagram}>
    //         instagram
    //       </a>
    //     );
    //   }
    // }

    return (
      <PluginWrapper>
        <PluginCloseButton onClick={onSpotPopupClose} className="z-1" />
        <div className="absolute bottom-0 top-0 w-100 overflow-y-auto">
          <article className="ph3">
            <PluginSection>
              <PluginHeader>
                <SpotIcon icon={icon} />
                {name}
              </PluginHeader>
              {/* <PluginSubHeader>
                {}
              </PluginSubHeader> */}
              {!!poiData ? (
                <>
                  <img
                    className="w-100"
                    src={poiData.images[0]}
                    alt={poiData.name}
                  />
                  <PluginSection>
                    {/* {distanceToGeolocateInfo && (
                <p>
                  <small>{distanceToGeolocateInfo}</small>
                </p>
              )} */}

                    <PluginText>
                      {ReactHtmlParser(poiData.description, {
                        transform: this.transformATagToOpenLinkInNewWindow,
                      })}
                    </PluginText>
                    {/* <p>
                      <span className="ttu mr1">Email:</span>
                      <br />
                      <a href={`mailto:${poiData.email}`}>{poiData.email}</a>
                    </p> */}
                    {poiData.homepage && (
                      <>
                        <p>
                          <span className="ttu mr1">Homepage:</span>
                          <br />
                          <a href={`${poiData.homepage.href}`}>
                            {poiData.homepage.text}
                          </a>
                        </p>
                        {!!poiData.phone && (
                          <p>
                            <span className="ttu mr1">Telefon:</span>
                            <br />
                            <a href={`tel:${poiData.phone}`}>{poiData.phone}</a>
                          </p>
                        )}
                      </>
                    )}
                    <span className="ttu mr1">Adresse:</span>
                    <address className="fs-normal fw2">
                      {poiData.location_name}
                      <br />
                      {poiData.street}
                      <br />
                      {poiData.zip} {poiData.city}
                    </address>

                    {/* <p className="center">
                      {socialLinks.length > 0 &&
                        socialLinks
                          .map((t) => t)
                          .reduce((prev, curr) => [prev, " | ", curr])}
                    </p> */}
                  </PluginSection>
                  <PluginSection className="mv4 actions flex justify-center">
                    <Action
                      onClick={() =>
                        this.navigateToSpotLocation(
                          selectedFeature.geometry.coordinates[1],
                          selectedFeature.geometry.coordinates[0]
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faLocationArrow} />
                      Bring mich hin
                    </Action>
                  </PluginSection>
                </>
              ) : (
                <>
                  <img
                    className="w-100"
                    src={selectedFeature.properties.picture_url}
                    alt={name}
                  />
                </>
              )}
            </PluginSection>
            {isDeinUlm && (
              <PluginSection>
                <PluginText>
                  {ReactHtmlParser(selectedFeature.properties.description, {
                    transform: this.transformATagToOpenLinkInNewWindow,
                  })}
                </PluginText>
              </PluginSection>
            )}
          </article>
        </div>
      </PluginWrapper>
    );
  }
}

export default SpotPopup;
